import React, { useState, useEffect } from "react";
import translate from "../../i18n/translate";
import TextFieldGroup from "../common/TextFieldGroup";
import { useIntl } from "react-intl";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { verfiyUser, callResendCode } from "./../../actions/userAction";
import Message from "./../common/Message";
import Notiflix from "notiflix";
import Spinner from "../ui/spinner/Spinner";

import Countdown from "react-countdown";
import humanizeDuration from "humanize-duration";
import { Button } from "react-bootstrap";
import classnames from "classnames";
import VerificationInput from "react-verification-input";
import DynamicLogo from "shared/components/DynamicLogo";

const Verification = ({
  verfiyUser,
  callResendCode,
  isAuthenticated,
  massage,
  mobile,
  loading,
  isDarktheme,
}) => {
  const history = useHistory();
  const [timer, setTimer] = useState(180000);
  const intl = useIntl();

  const [virefyForm, setVirefyForm] = useState({
    virefy: "",
    mobile: history.location?.state?.mobile,
    sellerId:
      history.location?.state?.sellerId ||
      history.location.pathname.split("/")[2],
    userData: history.location?.state.userData,
  });

  useEffect(() => {
    document.title = "Sign In | Phone Play";
    if (isAuthenticated) {
      history.push("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const onChange = (e) => {
    setVirefyForm({ ...virefyForm, [e.target.name]: e.target.value });
  };
  const onSubmit = (e) => {
    e.preventDefault();
    if (virefyForm.mobile === history.location.state.mobile) {
      verfiyUser(
        history.location.pathname.split("/")[2],
        virefyForm,
        history
      ).finally(() => {});
    } else {
      Notiflix.Notify.failure("Validation Error");
    }
  };

  const _updateTimer = (props) => {
    setTimer(props.total);
  };
  const _resendCode = () => {
    if (timer === 0) {
      setTimer(180000);
      callResendCode(virefyForm.sellerId);
    }
  };
  return (
    <section className="auth signin">
      <div className="container">
        <div className="row justify-content-md-center">
          <div className="card-wrapper">
            <div className="card fat">
              <div className="card-body">
                <div className="brand">
                  <DynamicLogo />
                </div>
                <h4 className="card-title text-center">
                  {translate(
                    "We sent you a confirmation code to your mobile number"
                  )}{" "}
                  <br /> (xxx)-xxx-xx
                  {history.location.state.mobile.slice(8, 10)}
                </h4>

                <h6 className="card-subtitle text-center text-muted pb-0">
                  <Button
                    variant="link"
                    className="py-0 px-1 text-muted"
                    onClick={_resendCode}
                    disabled={timer !== 0}
                  >
                    {translate("Resend code")}
                  </Button>
                  <Countdown
                    date={Date.now() + timer}
                    onTick={_updateTimer}
                    onComplete={_updateTimer}
                    renderer={(props) => (
                      <span className={classnames({ hidden: timer === 0 })}>
                        (
                        {humanizeDuration(props.total, {
                          language: intl.locale,
                          units: ["m", "s"],
                        })}
                        )
                      </span>
                    )}
                  />
                </h6>

                {massage !== null &&
                  massage !== "" &&
                  massage !== undefined && <Message msg={massage} />}

                <form
                  method="POST"
                  className="verification-validation"
                  noValidate=""
                  onSubmit={(e) => onSubmit(e)}
                >
                  <VerificationInput
                    autoFocus={true}
                    placeholder="-"
                    value={virefyForm.random_number}
                    onChange={(str) => {
                      setVirefyForm({ ...virefyForm, virefy: str });
                    }}
                    classNames={{
                      container: "container-input",
                      character: "character",
                      characterInactive: "character--inactive",
                      characterSelected: "character--selected blink",
                    }}
                    style={{ direction: "ltr" }}
                  />

                  <div className="form-group mb-0 mt-4 actions">
                    <button
                      type="submit"
                      className="btn btn-primary btn-block"
                      disabled={loading}
                    >
                      {translate("Sign in")}
                    </button>
                  </div>
                </form>
              </div>
            </div>
            <div className="mt-4 text-center">
              {translate("Don't have an account?")}{" "}
              <a href="/signup">{translate("Sign up")}</a>
            </div>
          </div>
        </div>
      </div>
      {loading && <Spinner />}
    </section>
  );
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  massage: state.error.massage,
  loading: state.auth.userDetailsLoading,
  isDarktheme: state.darkTheme.isDarktheme,
});

export default connect(mapStateToProps, { verfiyUser, callResendCode })(
  Verification
);
